import { Link, NavLink, Outlet } from "react-router-dom"
import { clearSession } from "../lib/auth"
import { config } from "../lib/config"
import { useEmpresa } from "./context/EmpresaContext"

const navClass = ({ isActive }: { isActive: boolean }) =>
  `block rounded-lg px-3 py-2 text-sm font-medium ${isActive ? "bg-brand-600 text-white" : "text-slate-700 hover:bg-slate-100"}`

export const AppShell = () => {
  const { me, empresas, empresaId, setEmpresaId, loading } = useEmpresa()

  const handleLogout = () => {
    clearSession()
    localStorage.removeItem("fiscalhub_empresa_id")
    window.location.href = "/"
  }

  return (
    <div className="min-h-screen bg-slate-50 lg:flex">
      <aside className="w-full border-b border-slate-200 bg-white lg:w-64 lg:min-h-screen lg:border-b-0 lg:border-r">
        <div className="border-b border-slate-200 px-4 py-4">
          <Link to="/" className="text-lg font-semibold text-slate-900">
            {config.appName}
          </Link>
          <p className="mt-1 truncate text-xs text-slate-500">{me?.email}</p>
        </div>
        <div className="px-4 py-3">
          <label htmlFor="empresa-select" className="text-xs font-medium uppercase text-slate-500">
            Empresa ativa
          </label>
          <select
            id="empresa-select"
            className="mt-1 w-full rounded-lg border border-slate-300 px-2 py-2 text-sm"
            value={empresaId ?? ""}
            onChange={(e) => setEmpresaId(e.target.value)}
            disabled={loading || empresas.length === 0}
          >
            {empresas.map((e) => (
              <option key={e.id} value={e.id}>
                {e.nome_fantasia || e.razao_social}
              </option>
            ))}
          </select>
        </div>
        <nav className="space-y-1 px-3 pb-6" aria-label="Painel">
          <NavLink to="/app" end className={navClass}>
            Dashboard
          </NavLink>
          <NavLink to="/app/planos" className={navClass}>
            Planos
          </NavLink>
          <NavLink to="/app/nfe" end className={navClass}>
            NF-e
          </NavLink>
          <NavLink to="/app/nfe/faixa" className={navClass}>
            Faixa da série
          </NavLink>
          <NavLink to="/app/certificados" className={navClass}>
            Certificados
          </NavLink>
          <NavLink to="/app/dfe" className={navClass}>
            DFe recebidas
          </NavLink>
          <NavLink to="/app/webhooks" className={navClass}>
            Webhooks
          </NavLink>
          <NavLink to="/app/ia" className={navClass}>
            IA / NCM
          </NavLink>
          <NavLink to="/app/auditoria" className={navClass}>
            Auditoria
          </NavLink>
          {me?.is_gestor && (
            <NavLink to="/app/gestao" className={navClass}>
              Gestão
            </NavLink>
          )}
          {me?.is_super_admin && (
            <NavLink to="/app/super-admin" className={navClass}>
              Super Admin
            </NavLink>
          )}
        </nav>
        <div className="px-4 pb-6">
          <button
            type="button"
            onClick={handleLogout}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            Sair
          </button>
        </div>
      </aside>
      <main className="flex-1 p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  )
}
